<template>
  <div class="bread-crumb half-px-border">
    <div class="bread-crumb-item" @click="spreadTreeItem(item, index)" v-for="(item, index) in list">
      {{ item[labelKey] }}
      <div class="arrow-img">
        <arrow-svg v-if="index < list.length - 1"></arrow-svg>
      </div>
    </div>
    <p class="bread-crumb-placeholder"></p>
  </div>
</template>
<script type="text/ecmascript-6">

import arrowSvg from './arrow-svg';

export default {
  name: 'bread-crumb',
  props: {
    list: {
      type: Array,
      default: []
    },
    spreadTreeItem: {
      type: Function
    },
    labelKey:{
      type: String,
      default:'name'
    }
  },
  data() {
    return {
    };
  },
  computed: {

  },
  components: {
    arrowSvg
  }
};
</script>
<style lang="scss" scoped>
@import '~assets/css/variable.scss';

.bread-crumb {
  width: calc(100% - #{px(60)});
  padding: 0 px(30);
  height: px(68);
  background: #fff;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  overflow-x: scroll;
  font-size: px(26);
  color: #1e78c8;
  &::-webkit-scrollbar {
    display: none;
  }
  .bread-crumb-item {
    height: px(50);
    line-height: px(50);
    //border: 0.1px solid #d7dce6;
    padding: 0 px(12);
    margin-right: px(42);
    position: relative;
    flex-shrink: 0;
    cursor: pointer;
    &:last-of-type {
      color: #0a0f1e;
      margin-right: 0;
      cursor: default;
      &:after {
        display: none;
      }
    }
    .arrow-img {
      position: absolute;
      top: 4px;
      right: -30px;
    }
  }
  .bread-crumb-placeholder {
    flex-shrink: 0;
    height: 100%;
    width: px(30);
  }
}
</style>
